// extracted by mini-css-extract-plugin
module.exports = {"container":"NoteReview_container__uGWDu","buttonSwitcher":"NoteReview_buttonSwitcher__ks4nr"};